import { useCallback, useState } from 'react';

import { Platform } from 'react-native';

import { useSelector } from 'react-redux';

import { useFocusEffect } from '@react-navigation/native';

import { selectAppState } from 'store/config/selectors.ts';

// Created for the Web app purpose when multiple duplicated pages are "pushing" into the
// navigation stack - to release not focused pages components from images and tickers when page is not focused.
function useScreenFocused() {
    const appState = useSelector(selectAppState);

    const [focused, setFocused] = useState(false);

    useFocusEffect(
        useCallback(() => {
            setFocused(true);

            return () => {
                setFocused(false);
            };
        }, []),
    );

    return {
        screenFocused: Platform.select({
            web: focused && appState === 'active',
            default: focused,
        }),
    };
}

export default useScreenFocused;
